import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import RoleHeader from './components/table-header.vue';
import { handleError } from '@blade/common/utils/handle-error';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import { EventBus } from '@blade/common';
import { getList, deleteRole } from '@blade-sxp/account/api/role';
import colors from '@/styles/color.scss';
let default_1 = class default_1 extends Vue {
    list = [];
    selectOpts = [];
    outerPageSize = 10;
    roles = [];
    initRoles = [];
    totalNum = 0;
    currNum = 1;
    listLoading = false;
    isFullscreen = false;
    openMode = 'add';
    editId = '';
    state = '';
    colorStyles(state) {
        if (state === 'DISABLE') {
            return `background:${colors.dodBlack}`;
        }
        else if (state === 'ENABLE') {
            return `background:${colors.greenText0}`;
        }
        else {
            return `background:${colors.dodOrange}`;
        }
    }
    mounted() {
        this.getData({});
    }
    async getData(obj) {
        this.roles = [];
        this.listLoading = true;
        try {
            const res = await getList({
                page: this.currNum,
                size: this.outerPageSize,
                pageOrderList: [],
                ...obj,
            });
            this.roles = res.role_vos;
            EventBus.$emit('getInitRoles', res.role_vos);
            this.totalNum = res.total_size;
        }
        catch (e) {
            handleError(e);
        }
        finally {
            this.listLoading = false;
        }
    }
    // 打开详情
    openDetail(id) {
        this.$refs.headerRef.addDialogVisible = true;
        this.openMode = 'detail';
        this.editId = id;
    }
    handleEdit(row) {
        this.$refs.headerRef.addDialogVisible = true;
        this.openMode = 'edit';
        this.editId = row.role_id;
        this.state = row.state;
    }
    handlePagination(value) {
        this.currNum = value;
        this.getData({});
    }
    handleSizeNavigation(value) {
        this.outerPageSize = value;
    }
    handleSizeChange(value) {
        this.outerPageSize = value;
        this.handlePagination(1);
    }
    handleFullScreen() {
        if (!this.isFullscreen) {
            document.body.requestFullscreen();
        }
        else {
            document.exitFullscreen();
        }
        this.isFullscreen = !this.isFullscreen;
    }
    handleRefresh() {
        this.currNum = 1;
        this.getData({});
    }
    changeRoles(dimArray = []) {
        this.roles = dimArray;
    }
    onRouteChange(to, from) {
        if (to && from && to.path === from.path) {
            this.getData({});
        }
    }
    onLocaleChange(newVal) {
        this.getData({});
    }
    // 通过时间排序
    sortTable(column) {
        let pageOrderList = [];
        if (column.prop === 'createTime') {
            if (column.order === 'ascending') {
                pageOrderList.push({
                    orderField: 'createTime',
                    orderType: 'ASC',
                });
            }
            else {
                pageOrderList.push({
                    orderField: 'createTime',
                    orderType: 'DESC',
                });
            }
        }
        else {
            if (column.order === 'ascending') {
                pageOrderList.push({
                    orderField: 'updateTime',
                    orderType: 'ASC',
                });
            }
            else {
                pageOrderList.push({
                    orderField: 'updateTime',
                    orderType: 'DESC',
                });
            }
        }
        this.getData({ pageOrderList });
    }
    async handleDelete(id, name) {
        this.$elconfirm(`${this.$t('confirmDelete').toString()} ${name} ?`, `${this.$t('title')}`, {
            type: 'warning',
            confirmButtonText: this.$t('ok').toString(),
            cancelButtonText: this.$t('cancel').toString(),
            callback: async (action) => {
                if (action === 'confirm') {
                    try {
                        await deleteRole(id);
                        this.getData({});
                        this.$elmessage.success(`${this.$t('successDelete')} ${name}`);
                    }
                    catch (e) { }
                }
            },
        });
    }
};
__decorate([
    Watch('$route', { immediate: true, deep: true })
], default_1.prototype, "onRouteChange", null);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "onLocaleChange", null);
default_1 = __decorate([
    Component({
        name: 'RoleList',
        components: { 'role-header': RoleHeader, AuthItem },
        i18n: {
            messages: {
                'en-us': {
                    roleList: 'Role List',
                    role: 'Role',
                    creater: 'Creator',
                    organization: 'Department',
                    createTime: 'Create Time',
                    updater: 'Updater',
                    updateTime: 'Update Time',
                    status: 'Status',
                    edit: 'Edit',
                    delete: 'Delete',
                    operations: 'Option',
                    confirmDelete: 'Are you sure to delete role',
                    successDelete: 'Successfully delete role',
                    ok: 'Delete',
                    cancel: 'Cancel',
                    total: 'Total {msg} Items',
                    noEffective: 'Disable',
                    effect: 'Enable',
                    title: 'Warning',
                },
                zh: {
                    roleList: '角色列表',
                    creater: '创建人',
                    role: '角色',
                    organization: '组织架构',
                    createTime: '创建时间',
                    updater: '更新人',
                    updateTime: '更新时间',
                    status: '状态',
                    edit: '编辑',
                    delete: '删除',
                    operations: '操作',
                    confirmDelete: '确认删除角色',
                    successDelete: '成功删除',
                    ok: '删除',
                    cancel: '取消',
                    total: '总共 {msg} 条',
                    noEffective: 'Disable',
                    effect: 'Enable',
                    title: '警告',
                },
            },
        },
    })
], default_1);
export default default_1;
